<template>
  <t-switch
    v-model="hiddeOnDesktop"
    data-testid="hide-section-on-desktop"
    :label="$t('forms.hide_on_desktop')"
    :disabled="disabled"
  ></t-switch>
</template>

<script lang="ts" setup>
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TSwitch } from "@topol/twig-ui";
  import { computed } from "vue";

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const mjmlStore = useMjmlStore();

  const hiddeOnDesktop = computed({
    get() {
      return mjmlStore.getActiveSectionAttrString("css-class") &&
        mjmlStore.getActiveSectionAttrString("css-class") ==
          "hide_section_on_desktop"
        ? true
        : false;
    },
    set() {
      unsetHidingOnAllChildren();

      const css = mjmlStore.getActiveSectionAttrString("css-class");
      mjmlStore.updateSectionAttribute({
        prop: "css-class",
        value:
          css && css == "hide_section_on_desktop"
            ? null
            : "hide_section_on_desktop",
      });
    },
  });

  function unsetHidingOnAllChildren() {
    //@ts-expect-error
    const sectionIndex = mjmlStore.selectedSection.sectionIndex as number;

    const selection = mjmlStore.getSelectedSectionByIndex();

    selection.children.forEach((col: any, colIndex: number) => {
      col.children.forEach((block: any, blockIndex: number) => {
        mjmlStore.updateSpecificBlockAttribute({
          prop: "css-class",
          value: null,
          sectionIndex: sectionIndex,
          columnIndex: colIndex,
          blockIndex: blockIndex,
        });
      });
    });
  }
</script>
